import { useDebouncedValue } from '@/hooks/use-debounced-value';
import { queryKeys } from '@/lib/query-keys';
import { apiClient } from '@borradh-workspace/api-client';
import { serviceTreatmentOptionsResponseSchema } from '@borradh-workspace/contracts';
import { useQuery } from '@tanstack/react-query';

/** Shared by create and edit. The server resolves names without changing the selected fields. */
export function useServiceTreatmentOptions(
  organizationId: string | undefined,
  serviceName: string
) {
  const name = useDebouncedValue(serviceName.trim(), 600);
  return useQuery({
    queryKey: queryKeys.serviceFootage.treatmentOptions(organizationId, name),
    enabled: !!organizationId && name.length >= 3,
    staleTime: 5 * 60 * 1000,
    retry: false,
    queryFn: () =>
      apiClient.post(
        'organization-services/footage/treatment-options',
        { name },
        { schema: serviceTreatmentOptionsResponseSchema }
      ),
  });
}
